import {NamaPresenter} from "./NamaPresenter";
import {ajaxJSON, areEqual, areNotEqual, isEmptyOrNull, isNotEmptyOrNull} from "../common/NamaCommon";
import * as ts from "../common/Translator";
import {isArabic} from "../common/Translator";
import WizardTemplate from "../compiled-templates/WizardTemplate";
import * as NamaURLS from "../constants/NamaURLS";
import {destroyKendoWidgets} from "../views/list/CriteriaEditorWidget";
import {isModuleLoaded} from "../login/ClientCache";
import * as notifier from "../common/ErrorsNotification";

class StepData {
    constructor() {
        this.wizardFileId = null;
        this.stepper = null;
        this.steps = [];
        this.currentStep = 0;
        this.enabledSections = [];
        this.formData = {};
        this.metaData = {};
        this.focusedElementId = null;
        this.enabledFeatured = [];
        this.expandedGroups = [];
    }
}

let stepData = new StepData();
let questionTitleColumnClasses = "col-3 h2";
let questionBodyColumnClass = "col-6";

export class WizardPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        stepData.wizardFileId = that.place.params.get("id");
        let request = {wizardFileId: stepData.wizardFileId};
        ajaxJSON(NamaURLS.FetchWizardMetaData, {request: JSON.stringify(request)}, (result) => {
            stepData.metaData = result;
            if (!stepData.metaData) stepData.metaData = {};
            that.initWizard();
            that.drawWizard();
        });
    }

    initWizard() {
        let wizardTemplate = $(WizardTemplate({translateId: ts.translateId}));
        let domBody = $('#example');
        wizardTemplate.appendTo(domBody);
        $("#wizardExample").on("keypress", function (e) {
            if (e.which === 13) {
                $(this).next().focus();
                e.preventDefault();
            }
        });
        return wizardTemplate;
    }

    drawWizard() {
        let that = this;
        let wizardWindow = $('#wizard-window');
        destroyKendoWidgets(wizardWindow);
        $(stepData.expandedGroups).empty();
        let sections = stepData.metaData.sections;
        let wizardExample = $("#wizardExample");
        if (sections == null) {
            let widget = $("<form><label>No Question Found</label></form>");
            wizardExample.append(widget);
            return;
        }
        stepData.steps = [];
        let mySections = sections.filter(section => !section.hidden && that.isLoaded(section.licenseInfo));
        $("form.section-form").remove();
        $("#wizard-controllers").remove();
        that.updateEnabledFeatures(mySections);
        let buttonsRow = $(`<div class="py-2" style="display: flex;width: 30%;border: 1px solid #c5c5c5;border-radius: 10px"></div>`);
        let buttonsDiv = $(`<div id="wizard-controllers" style="position: relative"></div>`);
        wizardExample.append(buttonsDiv);
        buttonsDiv.append(buttonsRow);
        let previousBtn = $(`<div class="col"><button id="previousStep" class="wizard-controller-btn">${translateId("previous")}</button></div>`);
        let nextBtn = $(`<div class="col"><button id="nextStep" class="wizard-controller-btn">${translateId("next")}</button></div>`);
        let saveBtn = $(`<div class="col"><button id="saveWizard" class="wizard-controller-btn">${translateId("save")}</button></div>`);
        let selectiveApplyWizard = $(`<div class="col"><button id="selectiveApplyWizard" class="wizard-controller-btn">${translateId("selectiveApplyWizard")}</button></div>`);
        let applyBtn = $(`<div class="col"><button  id="applyWizard" class="wizard-controller-btn">${translateId("applyWizard")}</button></div>`);
        that.onStepSelect(buttonsRow, nextBtn, saveBtn, mySections, previousBtn, applyBtn, selectiveApplyWizard);
        for (let i = 0; i < mySections.length; i++) {
            let section = mySections[i];
            let sectionDiv = $(`<div id = '${section.id}' class="section-div"><div style="margin: auto"><h1>${(isArabic() ? section.arTitle : section.enTitle)}</h1></div></div>`);
            let formDiv = $(`<form id = '${section.id}-form' class="section-form"></form>`);
            if (stepData.currentStep !== i) $(formDiv).css("display", "none");
            formDiv.append(sectionDiv);
            wizardWindow.append(formDiv);
            stepData.steps.push({
                id: section.id,
                label: isArabic() ? section.arTitle : section.enTitle,
                index: i,
                selected: stepData.currentStep === i
            })
            stepData.enabledSections.push(section);
            let groups = section.groups;
            for (let group of groups) {
                that.createGroup(group, sectionDiv, section);
            }
        }
        wizardWindow.css("float", isArabic() ? "right" : "left");
        let stepperDiv = $('#stepper');
        stepperDiv.css("float", isArabic() ? "right" : "left");
        stepData.stepper = stepperDiv.kendoStepper({
            orientation: "vertical",
            linear: false,
            steps: stepData.steps,
            select: function (e) {
                stepData.currentStep = e.step.options.index;
                that.onStepSelect(buttonsRow, nextBtn, saveBtn, mySections, previousBtn, applyBtn, selectiveApplyWizard);
            }
        }).getKendoStepper();
        $(document).ready(function () {
            if (stepData.focusedElementId)
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(`#${stepData.focusedElementId}`).offset().top
                }, 500);
        });
    }

    createGroup(group, parentDiv, parent) {
        let that = this;
        if (that.shouldBeHidden(group.licenseInfo, group.relatedToFeature)) return;
        let questions = group.questions;
        group.groupTitle = isArabic() ? group.arGroupTitle : group.enGroupTitle;
        if (areNotEqual(group.groupTitle, parent.groupTitle) && areEqual(parent.wizardType, "group"))
            group.groupTitle = `${group.groupTitle} - ${parent.groupTitle}`;
        if (areNotEqual(group.groupTitle, parent.questionTitle) && areEqual(parent.wizardType, "question"))
            group.groupTitle = `${group.groupTitle} - ${parent.questionTitle}`;
        let groupDiv = that.createCollapsedGroupButton(parentDiv, group);
        for (let question of questions) {
            if (that.shouldBeHidden(question.licenseInfo, question.relatedToFeature)) continue;
            question.questionTitle = isArabic() ? question.arTitle : question.enTitle;
            question.questionHint = isArabic() ? question.arHint : question.enHint;
            that.updateAffectedQuestions(question);
            that.createQuestionItem(groupDiv, question);
            that.doQuestionAction(parentDiv, group.groupId, question, group);
            that.createSubQuestions(parentDiv, group.groupId, question);
            that.createSubGroups(groupDiv, question);
        }
        let subGroups = group.subGroups;
        for (let subGroup of subGroups) {
            that.createGroup(subGroup, groupDiv, group);
        }
    }

    onStepSelect(buttonsRow, nextBtn, saveBtn, mySections, previousBtn, applyBtn, selectiveApply) {
        let that = this;
        if (stepData.steps[stepData.currentStep]) {
            $('.section-form').css("display", "none");
            $(`.section-form#${stepData.steps[stepData.currentStep].id}-form`).css("display", "block");
        }
        buttonsRow.empty();
        if (stepData.currentStep === 0) {
            buttonsRow.append(nextBtn);
            buttonsRow.append(saveBtn);
        } else if (stepData.currentStep === mySections.length - 1) {
            buttonsRow.append(previousBtn);
            buttonsRow.append(saveBtn);
            buttonsRow.append(selectiveApply);
            buttonsRow.append(applyBtn);
        } else {
            buttonsRow.append(previousBtn);
            buttonsRow.append(nextBtn);
            buttonsRow.append(saveBtn);
        }
        $("#previousStep").kendoButton({
            click: function (e) {
                let index = 0;
                if (stepData.currentStep > index)
                    index = stepData.currentStep - 1;
                stepData.currentStep = index;
                stepData.stepper.select(stepData.currentStep);
                that.onStepSelect(buttonsRow, nextBtn, saveBtn, mySections, previousBtn, applyBtn, selectiveApply);
            }
        });
        $("#nextStep").kendoButton({
            click: function (e) {
                let index = stepData.enabledSections.length - 1;
                if (stepData.currentStep < index)
                    index = stepData.currentStep + 1;
                stepData.currentStep = index;
                stepData.stepper.select(stepData.currentStep);
                that.onStepSelect(buttonsRow, nextBtn, saveBtn, mySections, previousBtn, applyBtn, selectiveApply);
                $('.section-form').css("display", "none");
                $(`.section-form#${stepData.steps[stepData.currentStep].id}-form`).css("display", "block");
            }
        });
        $("#saveWizard").kendoButton({
            click: function (e) {
                let observable = new kendo.data.ObservableObject(stepData.metaData);
                let json = observable.toJSON();
                json.wizardFileId = stepData.wizardFileId;
                ajaxJSON(NamaURLS.SaveWizardData, {
                    request: JSON.stringify(json)
                }, (result) => {
                    notifier.showSuccess("Data Saved Successfully");
                })
            }
        });
        $("#applyWizard").kendoButton({
            click: function (e) {
                e.preventDefault();
                let observable = new kendo.data.ObservableObject(stepData.metaData);
                let json = observable.toJSON();
                json.wizardFileId = stepData.wizardFileId;
                ajaxJSON(NamaURLS.ApplyWizardData, {
                    request: JSON.stringify(json)
                }, (result) => {
                    notifier.showSuccess(translateId("operationSuccessfull"));
                });
            }
        });
        $("#selectiveApplyWizard").kendoButton({
            click: function (e) {
                e.preventDefault();
                stepData.metaData.selectiveRun = true;
                let observable = new kendo.data.ObservableObject(stepData.metaData);
                let json = observable.toJSON();
                json.wizardFileId = stepData.wizardFileId;
                ajaxJSON(NamaURLS.ApplyWizardData, {
                    request: JSON.stringify(json)
                }, (result) => {
                    notifier.showSuccess(translateId("operationSuccessfull"));
                    stepData.metaData.selectiveRun = false;
                });
            }
        });
        let wizardControllerBtnClass = $('.wizard-controller-btn');
        wizardControllerBtnClass.css("background-color", "#ff6000");
        wizardControllerBtnClass.css("font-size", "20px");
        wizardControllerBtnClass.css("color", "white");
        wizardControllerBtnClass.css("border-radius", "25px");
        wizardControllerBtnClass.css("width", "100%");
    }

    createCollapsedGroupButton(parentDiv, group, index) {
        if (!index)
            index = '';
        let groupId = `${group.groupId}${index}`;
        let groupDiv = $(`<div id = '${groupId}' class="container" style="margin:0 auto"></div>`);
        $(parentDiv).append(groupDiv);
        $(`#${groupId}`).kendoExpansionPanel({
            title: group.groupTitle,
            expanded: stepData.expandedGroups.indexOf(groupId) >= 0,
            expand: function (e) {
                stepData.expandedGroups.push(groupId);
            }, collapse: function (e) {
                stepData.expandedGroups.splice(stepData.expandedGroups.indexOf(groupId), 1);
            }
        });
        let groupLabel = $(".k-expander-title");
        groupLabel.css("color", "white");
        groupLabel.css("font-size", "34pt");
        let groupHeader = $(".k-expander-header");
        groupHeader.css("background-color", "#ff6000");
        groupHeader.addClass("py-0");
        groupHeader.css("border-radius", "10px")
        let expander = $(".k-expander");
        expander.css("margin", "30px auto");
        expander.css("padding", "0");
        expander.css("border-color", "white")
        $(".k-expander-indicator").css("color", "white");
        let contentWrapper = $(".k-expander-content-wrapper");
        contentWrapper.css("border", "1px solid #c5c5c5");
        contentWrapper.css("border-radius", "10px");
        return groupDiv;
    }

    updateEnabledFeatures(sections) {
        let that = this;
        for (let s = 0; s < sections.length; s++) {
            let section = sections[s];
            for (let g = 0; g < section.groups.length; g++) {
                let group = section.groups[g];
                for (let q = 0; q < group.questions.length; q++) {
                    that.addOrRemoveEnabledFeature(group.questions[q]);
                }
            }
        }
    }

    createQuestionItem(groupDiv, question, questionAnswerObject) {
        let that = this;
        let questionAnswer = null;
        if (questionAnswerObject) questionAnswer = questionAnswerObject.answer;
        if (!questionAnswer) questionAnswer = that.questionAnswer(question);
        if (question.updateAnswer && question.defaultsMap) questionAnswer = question.defaultsMap[question.currentObservedQuestionAnswer];
        if (!questionAnswer) questionAnswer = question.default;
        that.writeDefaultAnswer(question, questionAnswer, questionAnswerObject);
        that.createQuestionItemFormData(question, questionAnswerObject);
        question.updateAnswer = false;
        let type = question.type;
        let options = question.editorOptions;
        let onValueQuestion = that.findQuestion(question.onValueQuestionId);
        if (onValueQuestion) {
            for (let value of question.onValueQuestionValues) {
                if (value.onValue === onValueQuestion.answer.answer) {
                    options = value.options.condEditorOptions;
                    break;
                }
            }
        }
        let items = [];
        for (let option of options) {
            option.optionTitle = isArabic() ? option.arLabel : option.enLabel;
            option.optionHint = isArabic() ? option.arHint : option.enHint;
            if (that.shouldBeHidden(option.licenseInfo, option.relatedToFeature)) continue;
            items.push({
                label: option.optionTitle, value: option.value
            });
        }
        if (type == null) type = "MaskedTextBox";
        if (type === "CheckBox")
            that.createCheckBoxQuestion(groupDiv, question);
        else if (type === "CheckBoxGroup")
            that.createCheckBoxGroupQuestion(groupDiv, question, items);
        else if (type === "DatePicker")
            that.createDatePickerQuestion(groupDiv, question);
        else if (type === "TimePicker")
            that.createTimePickerQuestion(groupDiv, question);
        else if (type === "DropDown")
            that.createDropDownQuestion(groupDiv, question, items);
        else
            that.createTextBoxQuestion(groupDiv, question);
        let questionSelector = $(`#${question.id}`);
        questionSelector.change(function (e) {
            that.onAnswer(e, question, questionAnswerObject);
        });
        questionSelector.keyup(function (e) {
            if (e.keyCode === 13) {
                that.onAnswer(e, question, questionAnswerObject);
            }
        });
    }

    createCheckBoxQuestion(groupDiv, question) {
        let that = this;
        let checked = that.elementValue(question, !!question.default);
        let questionElement = $(`<div class="${questionTitleColumnClasses}"><label for="${question.id}">${question.questionTitle}</label> </div><div class="${questionBodyColumnClass}"><input class="k-checkbox k-checkbox-md k-valid" checked="${checked}" type="checkbox" id='${question.id}'></div>`);
        that.appendQuestionToGroup(groupDiv, question, questionElement);
        $(document).ready(function (e) {
            $(`#${question.id}`).prop("checked", checked);
        });
    }

    appendQuestionToGroup(groupDiv, question, questionElement) {
        $(groupDiv).append($(`<div style="text-align: start" class="row question-div" id="question-div${question.id}"></div>`).append(questionElement));
    }

    elementValue(question, defaultValue) {
        if (stepData.formData[question.id] !== undefined)
            return stepData.formData[question.id];
        return defaultValue;
    }

    createCheckBoxGroupQuestion(groupDiv, question, options) {
        let that = this;
        let values = that.elementValue(question, question.default ? question.default : []);
        let group = `<div class="${questionTitleColumnClasses}"><label for="${question.id}">${question.questionTitle}</label></div><div class="${questionBodyColumnClass}"><ul id="${question.id}"></ul></div>`;
        that.appendQuestionToGroup(groupDiv, question, group);
        $(`#${question.id}`).kendoCheckBoxGroup({
            dataTextField: "label",
            dataValueField: "value",
            items: options,
            layout: "horizontal",
            wrap: true,
            value: values
        });
    }

    createDatePickerQuestion(groupDiv, question) {
        let that = this;
        let date = that.elementValue(question, question.default);
        let datePicker = $(`<div class="${questionTitleColumnClasses}"><label for="${question.id}">${question.questionTitle}</label></div><div class="${questionBodyColumnClass}"><input style="width: 100%" id='${question.id}' title="${question.id}"/></div>`);
        that.appendQuestionToGroup(groupDiv, question, datePicker);
        $(`#${question.id}`).kendoDatePicker({
            start: question.dateStartEditorOption,
            depth: question.dateDepthEditorOption,
            format: question.dateOrTimeFormatEditorOption,
            value: date
        });
    }

    createTimePickerQuestion(groupDiv, question) {
        let that = this;
        let time = that.elementValue(question, question.default);
        let timePicker = $(`<div class="${questionTitleColumnClasses}"><label for="${question.id}">${question.questionTitle}</label></div><div class="${questionBodyColumnClass}"><input id='${question.id}' title="${question.id}"/></div>`);
        that.appendQuestionToGroup(groupDiv, question, timePicker);
        $(`#${question.id}`).kendoTimePicker({
            format: question.dateOrTimeFormatEditorOption,
            value: time
        });
    }

    createDropDownQuestion(groupDiv, question, options) {
        let that = this;
        let comboBox = $(`<div class="${questionTitleColumnClasses}"> <label for="${question.id}">${question.questionTitle}</label></div><div class="${questionBodyColumnClass}"><select id='${question.id}'></select></div>`);
        that.appendQuestionToGroup(groupDiv, question, comboBox);
        let dropDown = $(`#${question.id}`).kendoDropDownList({
            dataTextField: "label",
            dataValueField: "value",
            dataSource: options,
            optionLabel: isNotEmptyOrNull(question.questionHint) ? question.questionHint : ''
        }).data("kendoDropDownList");
        dropDown.value(that.elementValue(question, question.default ? question.default : ""));
        $(".k-dropdown").css("width", "100%")
    }

    createTextBoxQuestion(groupDiv, question) {
        let that = this;
        let text = that.elementValue(question, question.default);
        let textBox = $(`<div class="${questionTitleColumnClasses}"> <label for="${question.id}">${question.questionTitle}</label></div><div class="${questionBodyColumnClass}"><input type='text' id='${question.id}'/></div>`);
        that.appendQuestionToGroup(groupDiv, question, textBox);
        $(`#${question.id}`).kendoMaskedTextBox({
            placeholder: question.questionHint ? question.questionHint : '',
            value: text
        });
    }

    isLoaded(licenseInfo) {
        if (!isModuleLoaded(licenseInfo.module)) return false;
        return isModuleLoaded(licenseInfo.subModule);
    }

    shouldBeHidden(licenseInfo, relatedToFeature) {
        if (!this.isLoaded(licenseInfo)) return true;
        if (!relatedToFeature) return false;
        return !stepData.enabledFeatured.map(f => f.featureName).contains(relatedToFeature);
    }

    onAnswer(event, question, questionAnswerObject) {
        let that = this;
        stepData.focusedElementId = question.id;
        that.updateAnswer(event, question, questionAnswerObject);
        if (question.onAction === null || question.onAction === undefined) return;
        if (question.onAction && areEqual("changeQuestionAnswer", question.onAction.actionMethod)) that.changeQuestionAnswer(question);
        if (question.onAction && areEqual("enableOrDisableFeature", question.onAction.actionMethod)) that.addOrRemoveEnabledFeature(question);
        that.drawWizard();
    }

    doQuestionAction(sectionDiv, parentGroupId, question, parent) {
        let that = this;
        if (question.onAction === null || question.onAction === undefined) return;
        if (areEqual("createSubQuestionFromTemplate", question.onAction.actionMethod)) that.createSubQuestionsFromTemplate(sectionDiv, parentGroupId, question, parent);
    }

    createSubQuestionsFromTemplate(sectionDiv, parentGroupId, question, parent) {
        let that = this;
        let questionAns = that.questionAnswer(question);
        let questionsCount;
        let answerIsArray = questionAns instanceof Array;
        if (answerIsArray)
            questionsCount = questionAns.length;
        else
            questionsCount = questionAns;
        let templates = question.onAction.subQuestionsTemplate;
        if (isEmptyOrNull(questionsCount) || questionsCount === 0) {
            question.answer.templatesAnswer = [];
            return;
        }
        let nested = $("<div style='margin: auto'></div>");
        $(`#question-div${question.id}`).after(nested)
        if (!question.answer) question.answer = {};
        if (!question.answer.templatesAnswer) question.answer.templatesAnswer = [];
        for (let i = 0; i < templates.length; i++) {
            let template = templates[i];
            template.groupId = `${template.groupId}${i}`;
            if (that.shouldBeHidden(template.licenseInfo, template.relatedToFeature))
                continue;
            let groupQuestionsAnswer = [];
            if (question.answer.templatesAnswer.length <= i) {
                let groupAnswer = {"groupQuestionsAnswer": groupQuestionsAnswer};
                question.answer.templatesAnswer.push(groupAnswer);
            } else {
                groupQuestionsAnswer = question.answer.templatesAnswer[i].groupQuestionsAnswer;
            }
            let formGroupId;
            if (template.groupId || template.groupId !== parentGroupId) {
                formGroupId = template.groupId;
                template.groupTitle = isArabic() ? template.arGroupTitle : template.enGroupTitle;
            }
            let index = 0;
            let checked = [];
            let elements = $("#" + question.id + ">li");
            checked = $.map(elements, (e) => {
                return {label: $(e).find("label")[0].textContent, code: $(e).find("input")[0].value}
            });
            while (index < questionsCount) {
                let templateAnswer = {};
                if (groupQuestionsAnswer.length <= index) {
                    groupQuestionsAnswer.push(templateAnswer);
                    templateAnswer.answer = [];
                } else {
                    templateAnswer = groupQuestionsAnswer[index];
                }
                let groupIndex = index;
                index++;
                let innerTemplateDiv = that.createCollapsedGroupButton(nested, template, groupIndex + 1);
                $(document).ready(function () {
                    let groupTitle = `${template.groupTitle}`;
                    let elements = $("#" + question.id + ">li");
                    checked = $.map(elements, (e) => {
                        return {label: $(e).find("label")[0].textContent, code: $(e).find("input")[0].value}
                    });
                    if (checked.length !== 0)
                        groupTitle += ` : ${checked.filter((e) => areEqual(questionAns[groupIndex], e.code))[0].label}`;
                    else if (question.id.endsWith("Count"))
                        groupTitle = `${translateId(question.id.replace("Count", ""))}  ${groupIndex + 1}`;
                    else
                        groupTitle = `${groupTitle} ${groupIndex + 1}`;
                    if (areEqual(parent.wizardType, "group"))
                        groupTitle = `${groupTitle} - ${parent.groupTitle}`;
                    $($('div').find(`[aria-controls='${template.groupId}${groupIndex + 1}']`).children('.k-expander-title')[0]).text(groupTitle);
                });
                let questions = template.questions;
                let i = 0;
                for (i = 0; i < questions.length; i++) {
                    let innerQuestion = questions[i];
                    if (that.shouldBeHidden(innerQuestion.licenseInfo, innerQuestion.relatedToFeature))
                        continue;
                    let questionAnswerObject = {"id": innerQuestion.id};
                    let innerAnswers = templateAnswer.answer.filter(t => areEqual(t.id, innerQuestion.id));
                    if (innerAnswers && innerAnswers[0])
                        questionAnswerObject = innerAnswers[0];
                    else
                        templateAnswer.answer.push(questionAnswerObject);
                    let suffix = ` ${index}`;
                    let subQuestion = {};
                    subQuestion["required"] = innerQuestion.required;
                    subQuestion["id"] = innerQuestion.id + index;
                    subQuestion["arTitle"] = innerQuestion.arTitle;
                    subQuestion["enTitle"] = innerQuestion.enTitle;
                    if (innerQuestion.arHint) subQuestion["arHint"] = innerQuestion.arHint + suffix;
                    if (innerQuestion.enHint) subQuestion["enHint"] = innerQuestion.enHint + suffix;
                    subQuestion["type"] = innerQuestion.type;
                    subQuestion["default"] = innerQuestion.default;
                    subQuestion["dateStartEditorOption"] = innerQuestion.dateStartEditorOption;
                    subQuestion["dateDepthEditorOption"] = innerQuestion.dateDepthEditorOption;
                    subQuestion["dateFormatEditorOption"] = innerQuestion.dateFormatEditorOption;
                    subQuestion["editorOptions"] = innerQuestion.editorOptions;
                    subQuestion["onValueQuestionId"] = innerQuestion.onValueQuestionId;
                    subQuestion["onValueQuestionValues"] = innerQuestion.onValueQuestionValues;
                    subQuestion["licenseInfo"] = innerQuestion.licenseInfo;
                    subQuestion["answer"] = questionAnswerObject;
                    subQuestion.questionTitle = isArabic() ? subQuestion.arTitle : subQuestion.enTitle;
                    subQuestion.questionHint = isArabic() ? subQuestion.arHint : subQuestion.enHint;
                    that.createQuestionItem(innerTemplateDiv, subQuestion, questionAnswerObject);
                    that.createSubQuestions(innerTemplateDiv, formGroupId, subQuestion);
                }
                that.terminateArrayFromEnd(templateAnswer.answer, i);
            }
            that.terminateArrayFromEnd(groupQuestionsAnswer, index);
        }
    }

    terminateArrayFromEnd(list, lastIndex) {
        for (let i = list.length - 1; i > lastIndex; i--) {
            list.pop();
        }
    }

    updateAffectedQuestions(question) {
        let that = this;
        let anotherQuestions = that.findAffectedQuestions(question)
        if (!anotherQuestions) return;
        for (let anotherQuestion of anotherQuestions) {
            anotherQuestion.defaultsMap = that.findEffectsAnswer(anotherQuestion, question);
        }
    }

    findEffectsAnswer(effectedQuestion, question) {
        if (!question.onAction) return;
        let effects = question.onAction.effects;
        if (!effects) return;
        for (let effect of effects) {
            let id = effect.questionId;
            if (effectedQuestion.id === id) return effect.values;
        }
    }

    changeQuestionAnswer(question) {
        let that = this;
        let affectedQuestions = that.findAffectedQuestions(question);
        if (!affectedQuestions) return;
        for (let affectedQuestion of affectedQuestions) {
            affectedQuestion.currentObservedQuestionAnswer = that.questionAnswer(question);
        }
    }

    addOrRemoveEnabledFeature(question) {
        let that = this;
        let answer = that.questionAnswer(question);
        let featureName = question.featureName;
        if (question.answerIsFeature)
            featureName = answer;
        let features = stepData.enabledFeatured.filter(feature => areNotEqual(feature.id, question.id));
        if (featureName && answer) features.push({id: question.id, featureName: featureName});
        stepData.enabledFeatured = features;
    }

    findAffectedQuestions(question) {
        let questions = [];
        if (!question.onAction) return questions;
        let effects = question.onAction.effects;
        if (!effects) return questions;
        for (let section of stepData.metaData.sections) {
            for (let group of section.groups) {
                for (let i = 0; i < group.questions.length; i++) {
                    let question = group.questions[i];
                    for (let effect of effects) {
                        let id = effect.questionId;
                        if (id === question.id) questions.push(question);
                    }
                }
            }
        }
        return questions;
    }

    findQuestion(id) {
        for (let section of stepData.metaData.sections) {
            for (let group of section.groups) {
                for (let i = 0; i < group.questions.length; i++) {
                    let question = group.questions[i];
                    if (id === question.id) return question;
                }
            }
        }
    }

    createSubQuestions(groupDiv, parentGroupId, question) {
        let questions = question.subQuestions;
        if (questions === null || questions === undefined) return;
        let that = this;
        for (let subQuestion of questions) {
            if (that.shouldBeHidden(subQuestion.licenseInfo, subQuestion.relatedToFeature)) continue;
            subQuestion.questionTitle = isArabic() ? subQuestion.arTitle : subQuestion.enTitle;
            subQuestion.questionHint = isArabic() ? subQuestion.arHint : subQuestion.enHint;
            that.createQuestionItem(groupDiv, subQuestion);
            that.doQuestionAction(groupDiv, parentGroupId, subQuestion);
            that.createSubQuestions(groupDiv, parentGroupId, subQuestion);
        }
    }

    createSubGroups(groupDiv, question) {
        let that = this;
        let groups = question.subGroups;
        if (groups === null || groups === undefined) return;
        if (isEmptyOrNull(groups)) return;
        for (let group of groups) {
            if (that.shouldShowSubGroup(question, group))
                that.createGroup(group, groupDiv, group);
        }
    }

    shouldShowSubGroup(question, group) {
        let that = this;
        if (!group.showGroupWithAnswer)
            return false;
        let value = that.elementValue(question, question.default);
        if (areEqual(value, group.showGroupWithAnswer))
            return true;
        if (value.indexOf(group.showGroupWithAnswer) > -1)
            return true;
        return false;
    }

    createQuestionItemFormData(question, questionAnswerObject) {
        let fieldId = question.id;
        if (!fieldId) return;
        let answer = this.questionAnswer(question);
        if (questionAnswerObject) answer = questionAnswerObject.answer;
        stepData.formData[fieldId] = answer;
    }

    updateAnswer(event, question, questionAnswerObject) {
        let that = this;
        let value = event.currentTarget.value;
        if (question.type === "CheckBoxGroup") {
            value = [];
            let elements = $(`#${event.currentTarget.id} > li > input`)
            for (let element of elements) {
                if (element.checked)
                    value.push(element.value);
            }
        } else if (question.type === "CheckBox") {
            value = $(`#${event.currentTarget.id}`).prop('checked');
        }
        let anotherQuestions = that.findAffectedQuestions(question);
        if (anotherQuestions) {
            for (let anotherQuestion of anotherQuestions) {
                anotherQuestion.updateAnswer = true;
            }
        }
        that.writeDefaultAnswer(question, value, questionAnswerObject);
    }

    writeDefaultAnswer(question, value, questionAnswerObject) {
        let that = this;
        if (value === null || value === undefined) return;
        if (questionAnswerObject) questionAnswerObject.answer = value;
        that.updateQuestionAnswer(question, value);
    }

    updateQuestionAnswer(question, value) {
        if (!question.answer) question.answer = {};
        question.answer.answer = value;
        stepData.formData[question.id] = value;
    }

    questionAnswer(question) {
        if (question.answer) return question.answer.answer;
    }
}